import { useState, useReducer, useEffect } from "react";
import { useSelector } from "react-redux";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import moment from "moment";

import * as actions from "../../../actions/multiSurvey";
import multiSurveyReducer from "../../../reducers/multiSurvey";
import { getTheme } from "../highChartTheme";
import React from "react";

type ParetoChartProps = {
  tierId: number;
  surveyId: number;
  surveyName: string;
  isRefreshDataRequired: object;
};

type SurveyMissQtnObj = {
  surveyID: number;
  questionID: number;
  question: string;
  frequency: number | string;
};

const initState = { paretoChartData: [] };

const ParetoChart = (props: ParetoChartProps) => {
  const { tierId, surveyId, surveyName, isRefreshDataRequired } = props;

  const isLightMode = useSelector((state: any) => state.theme.lightMode);

  const [state, dispatch] = useReducer(multiSurveyReducer, initState);

  const [animate, setAnimate] = useState<string>("");
  const [missReason, setMissReason] = useState<string[]>([]);

  const { paretoChartData } = state;

  useEffect(() => {
    if (surveyId)
      actions.getParetoChartData(dispatch, {
        surveyId,
        startDate: moment().subtract(60, "days").format("YYYY-MM-DD"),
        toDate: moment().format("YYYY-MM-DD"),
        tierId,
      });
  }, [surveyId, isRefreshDataRequired]);

  useEffect(() => {
    if (paretoChartData.length) {
      setMissReason(
        paretoChartData
          ?.map((x: SurveyMissQtnObj) => {
            return [
              x.question,
              typeof x.frequency === "string"
                ? parseInt(x.frequency)
                : x.frequency,
            ];
          })
          ?.map(([question]: string[]) => question)
      );
    }
    setTimeout(() => {
      setAnimate("animate");
    }, 250);
  }, [paretoChartData]);

  const options = {
    chart: {
      type: "column",
    },
    tooltip: {
      shared: true,
    },
    series: [
      {
        showInLegend: false,
        name: "",
        type: "column",
        colorByPoint: true,
        colors: ["#0286D6"],
        data: paretoChartData?.map((x: SurveyMissQtnObj) => {
          return [
            x.question,
            typeof x.frequency === "string"
              ? parseInt(x.frequency)
              : x.frequency,
          ];
        }),
      },
    ],
  };

  return (
    <div className="site-view tier-wrap admin-console-wrapper">
      <div
        className={"site-list " + animate}
        style={{
          backgroundColor: isLightMode ? "#d3d3d3" : "#2f3030",
        }}
      >
        <HighchartsReact
          highcharts={Highcharts}
          options={{
            ...options,
            ...getTheme(
              `${surveyName ? surveyName + " :" : ""}  Pareto Chart`,
              isLightMode,
              missReason
            ),
          }}
        />
      </div>
    </div>
  );
};

export default ParetoChart;
